module.exports = __webpack_public_path__ + "img/MomsOutScreenshot1_1920x1080.cdc5df21.png";